import axios from "axios";

export default function HistoriqueVisiteur(){
            const visiteurId = localStorage.getItem("VisiteurId");

        const urlShowHistoriqueVisiteur = `${process.env.REACT_APP_PHP_APP_URL}/visiteur/${visiteurId}/historique`;
        const getHistoriqueVisiteur=()=>{
        return (axios.get(urlShowHistoriqueVisiteur));
    }
    
    return {
        getHistoriqueVisiteur
    }
}